import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '@app/core/services/session.service';
import { tap } from 'rxjs/operators';

export const tokenInterceptorFn: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn) => {
  const token = localStorage.getItem('auth_token');
  const clonedRequest = request.clone({
    headers: request.headers.set('Authorization', `Bearer ${token}`)
  });

  return next(clonedRequest);
}

export const jwtInterceptorFn: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn) => {
  const router = inject(Router);
  const sessionService = inject(SessionService);
  
  return next(request).pipe(
    tap(
      () => sessionService.setSessionExpire(),
      (err: HttpErrorResponse) => {
        if (err.status === 401) {
          localStorage.removeItem('auth_token');
          localStorage.removeItem('loggedInUser');
          const message = window.btoa(`401 - Unauthorized Access / Session Expired`);
          const returnUrl = router.url;
          router.navigate(['/login'], { queryParams: { message, returnUrl } });
        }
      })
  );
}
